var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2563_68227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0308 5.92177L7.19705 0.0851473C7.14222 0.0303141 7.06817 0 6.99062 0C6.91308 0 6.839 0.0309154 6.78419 0.0857214L0.967957 5.92177C0.884559 6.00517 0.860067 6.13053 0.904978 6.23959C0.950463 6.34863 1.0566 6.41921 1.17439 6.41921H4.38164V13.7084C4.38164 13.8694 4.51227 14 4.67322 14H9.33834C9.49929 14 9.62992 13.8694 9.62992 13.7084V6.41918H12.8249C12.9427 6.41918 13.0489 6.34803 13.0943 6.23899C13.1398 6.12995 13.1142 6.00517 13.0308 5.92177Z",
    fill: "#233242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2563_68227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardArrowUp);
export default __webpack_public_path__ + "static/media/iconCardArrowUp.32e2ef670194536990e57e5ed73714ef.svg";
export { ForwardRef as ReactComponent };